import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { eur } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/prodotto/${product.slug}`} className="group block">
        <div className="relative overflow-hidden rounded-md bg-muted aspect-[4/5] mb-5">
          <img
            src={product.images?.[0]}
            alt={product.name}
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute top-4 left-4 text-[11px] uppercase tracking-widest bg-background/80 backdrop-blur px-3 py-1 rounded-full">{product.crystal}</span>
        </div>
        <div className="flex items-baseline justify-between">
          <h3 className="font-serif text-2xl leading-tight group-hover:text-gold transition-colors duration-300">{product.name}</h3>
          <span className="text-sm text-muted-foreground shrink-0 ml-4">{eur(product.price)}</span>
        </div>
        <p className="text-sm text-muted-foreground mt-1">{product.flower}</p>
      </Link>
    </motion.div>
  );
}
